// User reducer types
export const SET_AUTHENTICATED = "SET_AUTHENTICATED";
export const SET_UNAUTHENTICATED = "SET_UNAUTHENTICATED";
export const SET_USER = "SET_USER";
//export const LOADING_USER = "LOADING_USER";
export const MARK_NOTIFICATIONS_READ = "MARK_NOTIFICATIONS_READ";
export const FOLLOW_USER = "FOLLOW_USER";
export const UNFOLLOW_USER = "UNFOLLOW_USER";
export const SAVE_POST = "SAVE_POST";
export const UNSAVE_POST = "UNSAVE_POST";

// UI reducer types
export const SET_ERRORS = "SET_ERRORS";
export const LOADING_POSTS = "LOADING_POSTS";
export const LOADING_PROFILE = "LOADING_PROFILE";
export const LOADING_POSTDIALOG = "LOADING_POSTDIALOG";
export const LOADING_NEWPOST = "LOADING_NEWPOST";
export const LOADING_CREDENTIALS = "LOADING_CREDENTIALS";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const STOP_LOADING_POSTS = "STOP_LOADING_POSTS";
export const STOP_LOADING_PROFILE = "STOP_LOADING_PROFILE";
export const STOP_LOADING_POSTDIALOG = "STOP_LOADING_POSTDIALOG";
export const STOP_LOADING_NEWPOST = "STOP_LOADING_NEWPOST";
export const STOP_LOADING_CREDENTIALS = "STOP_LOADING_CREDENTIALS";


// Data reducer types
export const SET_POSTS = "SET_POSTS";
export const SET_POST = "SET_POST";
export const SET_SAVED_POSTS = "SET_SAVED_POSTS";
export const LIKE_POST = "LIKE_POST";
export const UNLIKE_POST = "UNLIKE_POST";
export const DELETE_POST = "DELETE_POST";
export const POST_POST = "POST_POST";
export const SUBMIT_COMMENT = "SUBMIT_COMMENT";
export const SET_PROFILE = "SET_PROFILE";
